<template>
  <div class="phone-container" :style="[container_Style]">
    <!-- <div class="titlebox" v-if="mytype == '1'" :style="bgtype == '1'?[bgColor]:[imgbg]"></div> -->
    <div class="titlebox" v-if="mytype == '2'">
      <div class="bgimg">
        <div class="white_block"></div>
      </div>
      <div class="phone_body">
        {{ mytitle }}
      </div>
    </div>
  </div>
</template>

<script>
import countdown from '@/components/countdown.vue'

export default {
  components: {
    countdown
  },
  props: {
    compData: {
      type: [Array,Object],
      default: () => []
    }
  },
  options: {
    styleIsolation: 'shared' // 解除样式隔离
  },
  data () {
    return {
      showDialog: false,
      curtab: {
        categoryList: []
      },
      curtabIndex: 0,
      queryInfo: {
        condition: {},
        currPage: 1,
        pageSize: 100
      },
      grouponWeappListDataList: [[], []],
      selectOne: '3',
      // unicOneGInfo: [],
    }
  },
  watch: {
    compData: {
      handler: function (newVal) {
        if (newVal) {
          this.$nextTick(() => {
            // console.log('thdfghjk---1', newVal, '|-0')
            return
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    // type
    mytype () {
      return this.compData?.attr?.['a0']?.value
    },
    // title
    mytitle () {
      return this.compData?.attr?.['a1']?.value
    },
    // 背景type
    bgtype () {
      return this.compData?.attr?.['a2']?.value
    },
    // 背景颜色
    bgColor () {
      return {
        'background': this.compData?.attr?.['a3']?.value,
      }
    },
    imgbg(){
      return {
        'background-image':  `url(${this.compData?.attr?.a4.value || '#fff'})`,
        'background-repeat': 'no-repeat',
        'background-position': '50%',
        'background-size': 'cover'
      }
    },
    // 数据
    goodsList () {
      return async (curtab, index) => {
        console.log('dddf',curtab, index)
        return
        // const _index = this.groupList.findIndex(item=>item.groupId == this.curtab.groupId)
        const _SeckillListData = await this.getgoods(curtab, index)
        // this.curtabIndex = _index
        this.grouponWeappListData = _SeckillListData
        this.$set(this.grouponWeappListDataList, index, _SeckillListData)
        // this.grouponWeappListDataList[index] = _SeckillListData
        return _SeckillListData
      }
    },
    listClass () {
      return this.compData?.attr?.['a1']?.value
    },
    // 样式
    container_Style () {

      switch (this.mytype) {
        case '1':
          return {
            'height': '0'
          }
        default:

          return {
          }
      }
    },
    image_Style () {
      return {
      }
    },
    fit () {
      return 'contain'
    },
    tabnameStyle () {
      return selected => {
        switch (this.navColorType){
          case '1':
            return {
              'color': selected ? this.selectColor : this.unselectColor
            }
          case '2':
            return {
              'color': selected ? this.selectColor : this.unselectColor
            }
          default:
            return{}
        }
      }
    },
  },
  created () {
  },

  mounted () {
    this.$nextTick(() => {
      // console.log('-----2',this.unicOneGInfo(this.unicOne?.activityCode,666))
    })
  },

  methods: {
    initData () {
    },
    hilarity () {
    },
    handleFinish (item) {
    },
  }
}
</script>

<style lang="scss" scoped>
.phone-container {
  width: 100%;
  height: 88px;
  box-sizing: border-box;
}
.titlebox{
  width: 100%;
  height: 100%;
  position: relative;
}
.bgimg{
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background-image: url("../../../../assets/images/myheader.png");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
.white_block{
  position: absolute;
  bottom: 10px;
  left: 20px;
  width: 30px;
  height: 30px;
  background: #fff;
  z-index: 9;
}
.phone_body{
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  height: 40px;
  line-height: 40px;
  padding: 0 20px 0 10px;
  text-align: center;
  overflow: hidden;
}
</style>
